// src/features/event/eventCard.ts
// Shared styles and constants for the event card UI (dark-header card, 420px)
import type React from "react";

export const withBase = (p: string) =>
    (import.meta.env.BASE_URL || "./") + p.replace(/^\/+/, "");

export const EVENT_LOGO = withBase("icons/ReadersNote_logo.svg");

export const eventCard: Record<string, React.CSSProperties> = {
    /** Full-page centering wrapper */
    wrap: {
        minHeight: "100vh",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        background: "#f8f9fb",
        padding: "24px 16px",
    },
    /** White rounded card */
    card: {
        width: 420,
        background: "#fff",
        borderRadius: 16,
        boxShadow: "0 4px 24px rgba(0,0,0,0.08), 0 1px 4px rgba(0,0,0,0.04)",
        overflow: "hidden",
    },
    /** Dark header area */
    header: {
        background: "#18181b",
        padding: "32px 32px 28px",
        display: "flex",
        flexDirection: "column",
        alignItems: "flex-start",
        gap: 8,
    },
    /** Logo icon container in the header */
    logoBox: {
        width: 48,
        height: 48,
        background: "#27272a",
        borderRadius: 12,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        marginBottom: 4,
    },
    /** Page title inside the header */
    title: {
        margin: 0,
        fontSize: 22,
        fontWeight: 800,
        color: "#fff",
        letterSpacing: "-0.4px",
    },
    /** Subtitle / description inside the header */
    subtitle: {
        margin: 0,
        fontSize: 13,
        color: "#a1a1aa",
        fontWeight: 500,
    },
    /** Card body */
    body: {
        padding: "28px 32px 32px",
        display: "flex",
        flexDirection: "column",
    },
    /** Primary CTA / submit button */
    ctaBtn: {
        height: 48,
        background: "#18181b",
        color: "#fff",
        border: "none",
        borderRadius: 10,
        fontSize: 15,
        fontWeight: 700,
        cursor: "pointer",
        transition: "background 0.15s",
        WebkitTapHighlightColor: "transparent",
        touchAction: "manipulation",
    },
    /** Thin horizontal rule */
    divider: {
        height: 1,
        background: "#f4f4f5",
        margin: "12px 0",
    },
};